import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

const Tab = ({ isActive, className, ...rest }) => (
  <button
    className={classnames(className, 'text-white py-1.5 bg-transparent text-sm', {
      'rounded-md bg-frolyPink font-semibold': isActive,
    })}
    {...rest}
  />
)

const TabSwitch = ({ tabs, onChange, buttonClassName }) => {
  return (
    <div className="bg-woodsmokeBlack flex rounded-md">
      {tabs.map(tab => (
        <Tab
          isActive={tab.isActive}
          onClick={e => {
            e.preventDefault()
            onChange(tab)
          }}
          key={tab.key}
          className={`${buttonClassName} md:w-${tab.width} `}
        >
          {tab.label}
        </Tab>
      ))}
    </div>
  )
}

TabSwitch.propTypes = {
  onChange: PropTypes.func.isRequired,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      isActive: PropTypes.bool,
    })
  ),
  buttonClassName: PropTypes.string,
}

export default TabSwitch
